export const getPortalBrands = (API, request, callback) => {
    API.get(`foodbrands`, { params: request }).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}